import { functions } from "utils/firebase";

// Send custom push notification with title and message to a list of users
export const sendCustomPushNotification = async (title, message, userIds) => {
  try {
    const sendCustomNotification = functions.httpsCallable(
      "sendCustomNotification"
    );
    const result = await sendCustomNotification({ title, message, userIds });
    return result.data;
  } catch (error) {
    console.error("Error sending push notifications:", error);
    throw error;
  }
};
